import axios from "axios";

import config from "./config";

//CALLBACKS
const callback = {
  success: response => {
    return response.data;
  }
  /*errorConn: (error) => {
        return false;
    }*/
};

axios.interceptors.response.use(resp => {
  /*let v = resp.headers["vers"] || "default";
  if (v !== localStorage.getItem("vers") && resp.config.method == "get") {
    localStorage.setItem("vers", v);
    return window.location.reload(); // For new version, simply reload on any get
  }*/
  /*
   only version 1 | errors
   */
  const { data: { error } } = resp

  if(
      error
  ) {
    const { trace: { message } } = error

    if(
        message[0] === 'Unauthenticated.'
    ) {
      return redirectIsUnauthenticated()
    }

  }
  return Promise.resolve(resp);
}, error => {
  /*
   only version 2
   */
  const  { response } = error

  if (
      response
  ) {
    const { status } = response

    const list = {
      403: 'Lo sentimos no puedes realizar esta acción'
      , 401: 'Lo sentimos tu sesión finalizo'
    }

    if (
        status in list
    ) {
      window.location.replace('/error-'.concat(status))

      if (
          status === 401
      ) {
        return redirectIsUnauthenticated()
      }
    }
  }
  return Promise.reject(error)
});

/*end session */
function redirectIsUnauthenticated()
{
  localStorage.clear()
  return window.location.replace('/')
}

const postSendFile = (uri, token, data, version = 'v1') => {
  const request = axios.post(
    config.permisosApi.concat(version, uri)
    , data
    , config.axiosConfigSendFile(token)
  )
  return request.then(callback.success).catch(callback.errorConn)
}

//all services of Permisos , data
export default {
  get: (uri, token, version = "v1", data = null, signal = null) => {
    version = typeof version === "object" ? "v1" : version;
    const request = axios.get(
      config.permisosApi + version + uri,
      {...config.axiosConf(token), ...(data && {params: data}), ...(signal && {signal})}
    );
    return request.then(callback.success).catch(callback.errorConn);
  },
  post: (uri, token, data, version = "v1", response_type = "") => {
    const request = axios.post(
      config.permisosApi + version + uri,
      data,
      config.axiosConf(token, response_type)
    );
    return request.then(callback.success).catch(callback.errorConn);
  },
  put: (uri, token, data, version = "v1") => {
    const request = axios.put(
      config.permisosApi + version + uri,
      data,
      config.axiosConf(token)
    );
    return request.then(callback.success).catch(callback.errorConn);
  },
  patch: (uri, token, data, version = "v1") => {
    const request = axios.patch(
      config.permisosApi + version + uri,
      data,
      config.axiosConf(token)
    );
    return request.then(callback.success).catch(callback.errorConn);
  },
  delete: (uri, token, version = "v1", data = null, signal = null) => {
    const request = axios.delete(
      config.permisosApi + version + uri,
      {...config.axiosConf(token), ...(data && {params: data}), ...(signal && {signal})}
    );
    return request.then(callback.success).catch(callback.errorConn);
  }
  , postSendFile
};
